import { useTranslation } from "react-i18next";

import MTBreadcrumb from "@app-components/header/MTBreadcrumb";
import PaymentContent from "@app-components/policy/PaymentContent";
import { getRoutes } from "@app-utils/routes";

export default function PaymentPolicyPage() {
  const { t } = useTranslation();
  const routes = getRoutes(t);

  return (
    <div className="container policy faq-detail">
      <MTBreadcrumb items={[routes.home, routes.paymentPolicy]} />
      <div className="faq-detail-container">
        <div className="wrapper">
          <div className="faq-detail-header">
            <div className="faq-detail-header-container">
              <div className="faq-detail-title">{t("page.payment.title")}</div>
            </div>
          </div>
          <PaymentContent />
        </div>
      </div>
    </div>
  );
}
